import "./common/common.js";
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/element/css/autoplay';

document.addEventListener('DOMContentLoaded', () => {
	initSlider();
	locationRead();
	pickupRead();
})

function initSlider() {
	const swiper = new Swiper("#slide", {
		modules: [Autoplay],
		speed: 500,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false
		},
		breakpoints: {
			1025: {
				slidesPerView: 3,
				centeredSlides: true,
				spaceBetween: 10,
				slidesPerView: "auto",
			}
		}
	});
}


// topページpickup読み込み
async function pickupRead() {
	const responce = await fetch('/system/user/top/pickup-items-read.php');
	const result = await responce.json();
	if (result.success) {
		const pickupData = result.data;
		const pickupWrap = document.getElementById('item-wrap');
		if (Array.isArray(result.data) && result.data.length === 0) {
			// 配列が空の場合
			document.getElementById('pickup').remove();
		}else{
			pickupData.forEach((item) => {
				const li = document.createElement('li');
				li.classList.add('item');
				li.innerHTML = `
					<a href="/ticket/ticket.html?pi=${item['item_id']}">
						<div class="img-frame">
							<img src="${item['thumb_path']}" alt="">
						</div>
						<div class="wrap">
							<p class="location">${item['store_name']}</p>
							<h3>${item['product_name']}</h3>
							<p class="desc">${item['product_description']}</p>
						</div>
					</a>
				`;
				pickupWrap.appendChild(li);
			})
		}
	} else {
		console.error(result.message);
	}
}

// topページのスキー場読み込み
async function locationRead(){
	const responce = await fetch('/system/user/top/location-read.php');
	const result = await responce.json();
	if (result.success) {
		const locationData = result.data;
		const locationWrap = document.getElementById('location-wrap');
		if (Array.isArray(result.data) && result.data.length === 0) {
			// 配列が空の場合
			document.getElementById('location').remove();
		}else{
			locationData.forEach((item) => {
				const li = document.createElement('li');
				li.style.background = `url('${item.thumb_path}') center center / cover`;
				li.innerHTML = `
				<a href="/ticket/?store=${item.store_name}">
					<span class="city">${item.city}</span>
					<p class="facility">${item.store_name}</p>
				</a>
				`;
				locationWrap.appendChild(li);
			})
		}
	} else {
		console.error(result.message);
	}
}